<template>
  <v-container fill-height>
    <v-layout text-center row wrap align-center>
      <v-flex xs12>
        <v-img :src="require('../assets/logo.png')" class="my-3" contain height="100"></v-img>
        <div v-if="driver.name">
          <h1
            class="headline blue-grey--text text--darken-1 mt-5"
          >Guten Morgen {{ driver.name.split(" ")[0] }}!</h1>

          <div class="mt-10">
            <v-btn to="/route" color="green" dark large>Ich bin wach</v-btn>
          </div>
        </div>
        <div v-else>
          <h1 class="headline blue-grey--text text--darken-1 mt-5">Guten Morgen!</h1>

          <div class="mt-10">
            <v-btn to="/driver" color="green" dark large>Ich bin wach</v-btn>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  computed: {
    driver() {
      return this.$store.state.driver;
    }
  }
};
</script>
